import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export async function fetchProducts(category) {
  const params = category && category !== "All" ? { category } : {};
  const { data } = await api.get("/products", { params });
  return data;
}

export async function fetchProduct(id) {
  const { data } = await api.get(`/products/${id}`);
  return data;
}

export async function fetchCategories() {
  const { data } = await api.get("/categories");
  return data.categories;
}

export async function createCheckoutSession(items, originUrl, email) {
  const payload = {
    items: items.map((i) => ({
      product_id: i.product_id,
      quantity: i.quantity,
      size: i.size,
    })),
    origin_url: originUrl,
    customer_email: email || null,
  };
  const { data } = await api.post("/checkout/session", payload);
  return data;
}

export async function getCheckoutStatus(sessionId) {
  const { data } = await api.get(`/checkout/status/${sessionId}`);
  return data;
}
